export default __webpack_public_path__ + "static/media/SWT0210.34I-20580_-16354_0.20b6f8de.jpg";